// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Bbde6","main-image":"Header_main-image__4Iu85"};